import { Col, Form, Row } from 'antd';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { useNestedDropdownHandler, getOptionsByPath } from '../../../utilsdata';
 
import {
    DatePickerField,
    SelectInput,
    InputField,
    AntdButton,
} from '../../../blueplanitUtils/InputField';
import { FINANCE, FINANCE_CATEGORYS } from '../../../Dropdownmanager';
 
export const FilterPanel = ({
    filterForm,
    handleSearch,
    handleClear,
    renderOptions,
    options,
    assignToUsers,
    setVisible,
    visible,
    setFilterState,
}) => {
    const NestedDatabucket = useSelector(
        (state) => state.dataBucket.NestedDatabucket
    );
 
    const categoryoptions = getOptionsByPath(NestedDatabucket, [
        FINANCE,
        FINANCE_CATEGORYS,
    ]);
 
    const { selectedId, handleChange } = useNestedDropdownHandler(
        categoryoptions,
        'department'
    );
 
    const HandleSelect = (val) => {
        setFilterState((prev) => ({ ...prev, category: val }));
        renderOptions(options, { name: val });
        setFilterState((prev) => ({ ...prev, subCategory: '' }));
    };
    return (
        <div className="page-wrapper">
            <div
                className="custom-scrollbar"
                style={{
                    position: 'fixed',
                    top: '64px',
                    left: visible ? 0 : '-250px',
                    width: 250,
                    height: '100vh',
                    backgroundColor: '#f5f5f5',
                    zIndex: 10,
                    borderRight: '1px solid #ccc',
                    paddingTop: 10,
                    transition: 'left 0.3s ease-in-out',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                {visible && (
                    <AntdButton
                        icon={<FontAwesomeIcon icon={faXmark} />}
                        type="text"
                        onClick={() => setVisible(false)}
                        style={{
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            zIndex: 1000,
                        }}
                    />
                )}
                <Form
                    layout="vertical"
                    style={{
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        marginTop: '10px',
                    }}
                >
                    <div
                        style={{
                            overflowY: 'auto',
                            flex: 1,
                            padding: '0 10px',
                        }}
                    >
                        <Row
                            className="custom-scrollbar"
                            gutter={[24, 0]}
                            style={{ height: '73vh', overflow: 'auto' }}
                        >
                            <Col span={24}>
                                <DatePickerField
                                    label="From Date"
                                    name="from"
                                    format="DD/MM/YYYY"
                                    value={filterForm.from}
                                    onChange={(date) =>
                                        setFilterState((prev) => ({ ...prev, from: date }))
                                    }
                                    disabledDate={(current) => {
                                        return (
                                            current &&
                                            (current > dayjs(filterForm.to).startOf('day') ||
                                                current > dayjs().endOf('day'))
                                        );
                                    }}
                                    style={{ width: '100%' }}
                                />
                            </Col>
 
                            <Col span={24} style={{ marginBottom: '-10px' }}>
                                <DatePickerField
                                    label="To Date"
                                    name="to"
                                    format="DD/MM/YYYY"
                                    value={filterForm.to}
                                    onChange={(date) =>
                                        setFilterState((prev) => ({ ...prev, to: date }))
                                    }
                                    style={{ width: '100%' }}
                                />
                            </Col>
 
                            <Col style={{ marginBottom: '-10px' }} span={24}>
                                <SelectInput
                                    label="Category"
                                    name="category"
                                    value={filterForm.category}
                                    onChange={(value) => {
                                        handleChange(value, HandleSelect);
                                        setFilterState((prev) => ({ ...prev, category: value }));
                                    }}
                                    options={categoryoptions}
                                    placeholder="Select"
                                    allowClear
                                    style={{ width: '100%' }}
                                />
                            </Col>
 
                            <Col style={{ marginBottom: '-10px' }} span={24}>
                                <SelectInput
                                    label="Sub Category"
                                    name="subCategory"
                                    value={filterForm.subCategory}
                                    onChange={(val) =>
                                        setFilterState((prev) => ({ ...prev, subCategory: val }))
                                    }
                                    options={
                                        filterForm.category
                                            ? getOptionsByPath(NestedDatabucket, [
                                                FINANCE,
                                                FINANCE_CATEGORYS,
                                                selectedId,
                                            ])
                                            : []
                                    }
                                    placeholder="Select"
                                    allowClear
                                    style={{ width: '100%' }}
                                />
                            </Col>
 
                            <Col style={{ marginBottom: '-10px' }} span={24}>
                                <SelectInput
                                    label="Spent By"
                                    name="spentBy"
                                    value={filterForm.spentBy}
                                    onChange={(val) =>
                                        setFilterState((prev) => ({ ...prev, spentBy: val }))
                                    }
                                    options={assignToUsers}
                                    placeholder="Select"
                                    allowClear
                                    showSearch
                                    optionFilterProp="label"
                                    style={{ width: '100%' }}
                                />
                            </Col>
 
                            <Col span={24}>
                                <InputField
                                    label="Purchase Details"
                                    name="purchaseDetails"
                                    placeholder="Enter details"
                                    value={filterForm.purchaseDetails}
                                    onChange={(e) =>
                                        setFilterState((prev) => ({
                                            ...prev,
                                            purchaseDetails: e.target.value,
                                        }))
                                    }
                                    style={{ width: '100%' }}
                                />
                            </Col>
 
                            <Col span={24}>
                                <InputField
                                    label="Invoice Number"
                                    name="invoice"
                                    placeholder="Enter invoice number"
                                    value={filterForm.invoice}
                                    onChange={(e) =>
                                        setFilterState((prev) => ({
                                            ...prev,
                                            invoice: e.target.value,
                                        }))
                                    }
                                    style={{ width: '100%' }}
                                />
                            </Col>
 
                            <Col span={24}>
                                <InputField
                                    label="Quantity"
                                    name="quantity"
                                    type="number"
                                    placeholder="Qty"
                                    value={filterForm.quantity}
                                    onChange={(e) =>
                                        setFilterState((prev) => ({
                                            ...prev,
                                            quantity: e.target.value,
                                        }))
                                    }
                                    style={{ width: '100%' }}
                                />
                            </Col>
 
                            <Col span={24}>
                                <InputField
                                    label="Amount"
                                    name="amount"
                                    type="number"
                                    placeholder="₹"
                                    value={filterForm.amount}
                                    onChange={(e) =>
                                        setFilterState((prev) => ({
                                            ...prev,
                                            amount: e.target.value,
                                        }))
                                    }
                                    style={{ width: '100%' }}
                                />
                            </Col>
 
                            <Col span={24}>
                                <SelectInput
                                    label="Mode of Transaction"
                                    name="transactionMode"
                                    value={filterForm.transactionMode}
                                    onChange={(val) =>
                                        setFilterState((prev) => ({
                                            ...prev,
                                            transactionMode: val,
                                        }))
                                    }
                                    options={getOptionsByPath(NestedDatabucket, [
                                        '688b02be3a0aa947944ce6b3',
                                        '688b101f3a0aa947944db45c',
                                    ])}
                                    placeholder="Select"
                                    allowClear
                                    style={{ width: '100%' }}
                                />
                            </Col>
                        </Row>
 
                        <Row
                            style={{
                                marginTop: '20px',
                                flex: 1,
                                display: 'flex',
                                justifyContent: 'center',
                            }}
                        >
                            <Col span={24}>
                                <div
                                    className="d-flex justify-content-end"
                                    style={{ gap: '5px' }}
                                >
                                    <AntdButton
                                        label="Search"
                                        type="primary"
                                        onClick={() => handleSearch()}
                                        style={{ borderRadius: '10px' }}
                                    />
                                    <AntdButton
                                        label="Clear"
                                        onClick={handleClear}
                                        style={{
                                            backgroundColor: '#6c757d',
                                            color: '#fff',
                                            border: 'none',
                                            borderRadius: '10px',
                                        }}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Form>
            </div>
        </div>
    );
};
 